import { Typography } from '@breetometer/components';
import { InfoIcon } from 'BreetAssets';
import { ModalParts } from 'BreetComponents';
import { viewHelpArticle } from 'BreetHelpers';
import { useFundRequestContext } from 'BreetHooks';

import CryptoFundingMethod from './forms/crypto/Crypto';
import FiatFundingMethod from './forms/fiat/Fiat';
import FundingMethod from './FundingMethod';
import Header from './Header';

const Child = () => {
	const { fundingMethod } = useFundRequestContext();

	const FundingComponent = fundingMethod === 'Crypto' ? CryptoFundingMethod : FiatFundingMethod;

	return (
		<ModalParts.Wrapper
			title='Fund Wallet'
			root='Fund Wallet'
			rightSheet
		>
			<div
				className='payment-request-form withdraw-request-form'
				data-testid='withdraw-form'
			>
				<Header />

				<FundingMethod />

				{!fundingMethod ? null : <FundingComponent />}

				<div className='funding-article'>
					<InfoIcon className='info-icon svg-dark' />
					<Typography
						as='a'
						onClick={viewHelpArticle('15830205')}
						className='color-tertiary-300'
					>
						How does funding work?
					</Typography>
				</div>
			</div>
		</ModalParts.Wrapper>
	);
};

export default Child;
